import { useEffect, useState } from "react";
import api, { API_BASE } from "../lib/api";
import { ArrowsClockwise, DownloadSimple } from "@phosphor-icons/react";

export default function AuditLogPage() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState("");

  const refresh = async () => {
    const { data } = await api.get("/audit-logs?limit=300");
    setLogs(data);
  };

  useEffect(() => { refresh().catch(() => {}); }, []);

  const filtered = logs.filter((l) =>
    !filter || `${l.action} ${l.resource} ${l.user_email}`.toLowerCase().includes(filter.toLowerCase())
  );

  const downloadExport = async (format) => {
    const API = `${API_BASE}/api`;
    const res = await fetch(`${API}/audit-logs/export?format=${format}`, { credentials: "include" });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `audit_log.${format}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-6 sm:p-8" data-testid="audit-page">
      <div className="flex items-end justify-between mb-6 flex-wrap gap-4">
        <div>
          <div className="font-mono text-[10px] tracking-[0.2em] text-zinc-400">MODULE / 04 · AUDIT LOG</div>
          <h1 className="font-display text-4xl font-black tracking-tighter mt-1">Audit Trail.</h1>
          <p className="text-sm text-zinc-500 mt-2">Immutable record of all sensitive operations.</p>
        </div>
        <div className="flex items-center gap-3">
          <input
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            placeholder="Filter…"
            data-testid="audit-filter-input"
            className="border-b border-zinc-300 focus:border-zinc-950 bg-transparent py-2 text-sm outline-none w-48"
          />
          <button onClick={() => downloadExport("csv")} className="text-xs font-mono text-zinc-700 hover:text-zinc-950 border border-zinc-300 hover:border-zinc-950 px-3 py-1.5 flex items-center gap-1" data-testid="audit-export-csv-btn">
            <DownloadSimple size={12} /> CSV
          </button>
          <button onClick={() => downloadExport("json")} className="text-xs font-mono text-zinc-700 hover:text-zinc-950 border border-zinc-300 hover:border-zinc-950 px-3 py-1.5 flex items-center gap-1" data-testid="audit-export-json-btn">
            <DownloadSimple size={12} /> JSON
          </button>
          <button onClick={refresh} className="text-xs font-mono text-zinc-500 hover:text-zinc-950 flex items-center gap-1">
            <ArrowsClockwise size={12} /> REFRESH
          </button>
        </div>
      </div>

      <div className="border border-zinc-950">
        <table className="w-full text-sm">
          <thead className="bg-zinc-950 text-white">
            <tr className="text-xs tracking-wider uppercase">
              <th className="text-left px-4 py-2.5">Timestamp</th>
              <th className="text-left px-4 py-2.5">User</th>
              <th className="text-left px-4 py-2.5">Action</th>
              <th className="text-left px-4 py-2.5">Resource</th>
              <th className="text-left px-4 py-2.5">Detail</th>
            </tr>
          </thead>
          <tbody data-testid="audit-tbody">
            {filtered.map((l) => (
              <tr key={l.id} className="border-b border-zinc-100 hover:bg-zinc-50">
                <td className="px-4 py-2 tnum text-xs text-zinc-500 whitespace-nowrap">
                  {new Date(l.timestamp).toLocaleString()}
                </td>
                <td className="px-4 py-2 font-mono text-xs">{l.user_email}</td>
                <td className="px-4 py-2"><span className="text-[10px] font-mono px-1.5 py-0.5 border border-zinc-300 uppercase">{l.action}</span></td>
                <td className="px-4 py-2 font-mono text-xs text-[#FF3E00]">{l.resource}</td>
                <td className="px-4 py-2 font-mono text-xs text-zinc-500 truncate max-w-xs">
                  {Object.keys(l.detail || {}).length > 0 ? JSON.stringify(l.detail) : "—"}
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={5} className="px-4 py-8 text-center font-mono text-xs text-zinc-400">NO RECORDS</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
